import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const STAGES = [
  { name: "Prospekt", count: 12, value: "500 000 kr", color: "#6c7788" },
  { name: "Kvalificering", count: 8, value: "320 000 kr", color: "#6683a7" },
  { name: "Offert", count: 5, value: "210 000 kr", color: "#d9a448" },
  { name: "Förhandling", count: 2, value: "140 000 kr", color: "#df934f" },
  { name: "Vunnet", count: 1, value: "78 500 kr", color: "#70a96d" },
];

const DealPipeline = ({ compact = false }) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    spacing={compact ? 0.35 : 0.5}
    sx={{ width: "100%" }}
  >
    {STAGES.map((stage, index) => (
      <Box
        key={stage.name}
        sx={{
          flex: 1,
          minWidth: 0,
          px: compact ? 1 : 1.25,
          py: compact ? 0.8 : 1.05,
          bgcolor: alpha(stage.color, 0.16),
          border: `1px solid ${alpha(stage.color, 0.26)}`,
          clipPath: {
            xs: "none",
            sm: index === 0
              ? "polygon(0 0, 92% 0, 100% 50%, 92% 100%, 0 100%)"
              : index === STAGES.length - 1
                ? "polygon(0 0, 100% 0, 100% 100%, 0 100%, 8% 50%)"
                : "polygon(0 0, 92% 0, 100% 50%, 92% 100%, 0 100%, 8% 50%)",
          },
          borderRadius: { xs: 1, sm: 0 },
        }}
      >
        <Typography sx={{ fontSize: compact ? 10.2 : 11.2, fontWeight: 560, color: "#182230" }}>
          {stage.name}
        </Typography>
        <Typography sx={{ mt: 0.2, fontSize: compact ? 9.4 : 10, color: "#667085" }}>
          {stage.count} affärer
        </Typography>
        <Typography sx={{ fontSize: compact ? 9.4 : 10, color: "#667085" }}>
          {stage.value}
        </Typography>
      </Box>
    ))}
  </Stack>
);

export default DealPipeline;
